import { useEffect, useMemo, useState } from 'react'
import { ProjectRole } from '@types'
import { Select, Option } from '@components/Select'
import { useTranslation } from 'react-i18next'

interface Props {
  required?: boolean
  role?: ProjectRole
  onSelectProjectRole: (role?: ProjectRole) => void
}

export const SelectProjectRole = (props: Props): JSX.Element => {
  const { t } = useTranslation()

  const { required, role, onSelectProjectRole } = props

  const options: Option[] = [
    {
      id: ProjectRole.RoleProjectAdmin,
      label: t('modules_project_components_SelectProjectRole_role_admin_label'),
      hint: t('modules_project_components_SelectProjectRole_role_admin_hint'),
      data: ProjectRole.RoleProjectAdmin,
    },
    {
      id: ProjectRole.RoleProjectReader,
      label: t('modules_project_components_SelectProjectRole_role_reader_label'),
      hint: t('modules_project_components_SelectProjectRole_role_reader_hint'),
      data: ProjectRole.RoleProjectReader,
    },
    {
      id: ProjectRole.RoleProjectCustomer,
      label: t('modules_project_components_SelectProjectRole_role_customer_label'),
      hint: t('modules_project_components_SelectProjectRole_role_customer_hint'),
      data: ProjectRole.RoleProjectCustomer,
    },
  ]

  const selectedOption: Option | undefined = useMemo(() => {
    return role && options.find((option) => option.id == role)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role])

  const [search, setSearch] = useState<string>(selectedOption?.label || '')
  const [showAllOptions, setShowAllOptions] = useState<boolean>(true)

  useEffect(() => {
    setSearch(selectedOption?.label || '')
  }, [selectedOption])

  const filteredOptions = useMemo(() => {
    if (showAllOptions) {
      return options
    }
    return options.filter((option) => option.label.toLowerCase().indexOf((search || '').toLowerCase()) !== -1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, showAllOptions])

  return (
    <Select
      required={required}
      label={t('modules_project_components_SelectProjectRole_label')}
      placeholder={t('modules_project_components_SelectProjectRole_placeholder')}
      search={search}
      onSearch={(value) => {
        setSearch(value)
        setShowAllOptions(false)
      }}
      selected={selectedOption}
      options={filteredOptions}
      onClick={(option) => {
        setShowAllOptions(true)
        if (option) {
          setSearch(option.label)
          onSelectProjectRole(option.id as ProjectRole)
        } else {
          setSearch('')
          onSelectProjectRole()
        }
      }}
    />
  )
}
